import type { ComponentKey } from "../../data/types";

export const SYSTEM_COMPONENT_COLORS: Record<ComponentKey, string> = {
  load: "var(--custom-teal-500)",
  pv: "var(--custom-amber-200)",

  gridImport: "var(--custom-gray-500)",
  gridExport: "var(--custom-green-300)",

  batteryEnergy: "var(--utility-success-900)",
  batteryCharge: "var(--custom-sky-500)",
  batteryDischarge: "var(--custom-fuchsia-100)",

  wind: "var(--custom-amber-500)",
  genset: "var(--custom-purple-200)",
};

export const DEFAULT_SELECTED_COMPONENTS: ComponentKey[] = [
  "load",
  "pv",
  "batteryEnergy",
  "gridImport",
];

export const SEVEN_HOURS_MS = 7 * 60 * 60 * 1000;

// No "Live" entry — the default (nothing selected) already means Live, so it isn't a
// choice a user picks from the list. "missing" here also covers "hasn't happened yet" (an
// in-progress day's un-elapsed hours) — see telemetryStatus.ts and JAA-880 for why that's
// intentional, not a bug. Shared between SystemComponentComparisonChart (Facility Page) and
// WidgetFilterBar (Custom Dashboard) so the same options/labels render in both places.
// "systemDiagnostics" is a third, independent option — unlike backfilled/missing it draws
// no chart overlay of its own; it only gates the tooltip's diagnostic footer (see
// OverlayStatus below and showDiagnosticFields in SystemComponentComparisonChart.tsx).
export type TelemetryStatusFilter = "backfilled" | "missing" | "systemDiagnostics";

// The subset of TelemetryStatusFilter that draws a ReferenceArea band and a legend swatch
// on the chart. Everywhere that renders bands/legend/no-data messaging must use this
// narrower type instead of TelemetryStatusFilter directly, or "systemDiagnostics" would
// produce a stray band and a mislabeled legend entry.
export type OverlayStatus = Extract<TelemetryStatusFilter, "backfilled" | "missing">;

export type TelemetryStatusOption = {
  value: TelemetryStatusFilter;
  label: string;
};

export const TELEMETRY_DRILLDOWN_OPTIONS: TelemetryStatusOption[] = [
  { value: "backfilled", label: "Backfilled" },
  { value: "missing", label: "Missing" },
  { value: "systemDiagnostics", label: "System Diagnostics" },
];

export const NO_STATUS_DATA_MESSAGE: Record<OverlayStatus, string> = {
  backfilled: "No backfilled data available",
  missing: "No missing data available",
};
